module.exports = __webpack_public_path__ + "img/TPM-banner-rigth.30d7dc23.svg";